import {computed} from "vue";
import {route} from "ziggy-js";
import {useUser} from "@/Store/User.js";

// The referral landing always renders dark regardless of the user's stored preference.
// route().current() can throw when Ziggy hasn't resolved the current route yet (e.g. during SSR).
export function usePageTheme() {
    const storeUser = useUser();

    return computed(() => {
        try {
            return route().current('referral') ? 'dark' : storeUser.theme;
        } catch (e) {
            return 'dark';
        }
    });
}
